import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismCheckbox } from '@mylighthouse/prism-ember';

interface SettingsCentralMappingTablesCellsEditableCheckboxCellSignature {
  Args: {
    isMixed?: boolean;
    setValue: (value: boolean) => void;
    value: boolean;
  };
}

export default class SettingsCentralMappingTablesCellsEditableCheckboxCell extends Component<SettingsCentralMappingTablesCellsEditableCheckboxCellSignature> {
  @action onChange(): void {
    this.args.setValue(!this.args.value);
  }

  <template>
    <div class="flex items-center">
      <PrismCheckbox
        @checked={{@value}}
        @indeterminate={{@isMixed}}
        @onChange={{this.onChange}}
      />
    </div>
  </template>
}
